import gql from 'graphql-tag'

export default gql`query projectClientInvoice{
    projectClientInvoice @client{
        project_id
        name
        project_clients{
          client{
            client_id
            name
          }
        }
        project_client_budgets{
          project_activity_budget_id
          client_id
          project_id
          project_activity_type_id
          project_activity_type{
            description
          }
          description
          stage
          amount_to_invoice
          budget_label
        }
    }
}`